(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-media"] && !Shopify.designMode) return;
  try {
    const initializeProductMediaCarousels = (root = document) => root.querySelectorAll('[data-product-media-carousel]').forEach((carousel) => {
    if (carousel.dataset.carouselReady === 'true') return;
    carousel.dataset.carouselReady = 'true';
    const track = carousel.querySelector('[data-media-track]');
    const slides = Array.from(carousel.querySelectorAll('[data-media-slide]'));
    const previous = carousel.querySelector('[data-media-previous]');
    const next = carousel.querySelector('[data-media-next]');
    const current = carousel.querySelector('[data-media-current]');
    const thumbnails = Array.from(carousel.querySelectorAll('[data-media-thumbnail]'));
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    let activeIndex = 0;
    let scrollFrame;

    const pauseInactiveVideo = () => {
      slides.forEach((slide, index) => {
        if (index !== activeIndex) slide.querySelectorAll('video').forEach((video) => video.pause());
      });
    };

    const update = () => {
      activeIndex = slides.reduce((closest, slide, index) => {
        const currentDistance = Math.abs(slide.offsetLeft - track.scrollLeft);
        const closestDistance = Math.abs(slides[closest].offsetLeft - track.scrollLeft);
        return currentDistance < closestDistance ? index : closest;
      }, 0);
      if (current) current.textContent = activeIndex + 1;
      if (previous) previous.disabled = activeIndex === 0;
      if (next) next.disabled = activeIndex === slides.length - 1;
      thumbnails.forEach((thumbnail, index) => thumbnail.setAttribute('aria-current', index === activeIndex ? 'true' : 'false'));
      pauseInactiveVideo();
    };

    const goTo = (index) => {
      const destination = Math.max(0, Math.min(slides.length - 1, index));
      slides[destination]?.scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : 'smooth', block: 'nearest', inline: 'start' });
    };

    previous?.addEventListener('click', () => goTo(activeIndex - 1));
    next?.addEventListener('click', () => goTo(activeIndex + 1));
    thumbnails.forEach((thumbnail) => thumbnail.addEventListener('click', () => goTo(Number(thumbnail.dataset.mediaIndex))));
    track?.addEventListener('keydown', (event) => {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      goTo(activeIndex + (event.key === 'ArrowRight' ? 1 : -1));
    });
    track?.addEventListener('scroll', () => {
      cancelAnimationFrame(scrollFrame);
      scrollFrame = requestAnimationFrame(update);
    }, { passive: true });
    update();
  });

  initializeProductMediaCarousels();
  document.addEventListener('shopify:section:load', (event) => initializeProductMediaCarousels(event.target));
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["quantity"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('glow-quantity')) {
    customElements.define(
      'glow-quantity',
      class extends HTMLElement {
        connectedCallback() {
          if (this.initialized) return;
          this.initialized = true;
          this.input = this.querySelector('input[type="number"]');
          this.minus = this.querySelector('button[name="minus"]');
          this.plus = this.querySelector('button[name="plus"]');

          if (!this.input || !this.minus || !this.plus) return;

          this.minus.addEventListener('click', () => this.change(-1));
          this.plus.addEventListener('click', () => this.change(1));
          this.input.addEventListener('change', () => this.sync());
          this.sync();
        }

        change(direction) {
          const step = Number(this.input.step) || 1;
          const current = Number(this.input.value) || Number(this.input.min) || 1;
          this.input.value = String(current + step * direction);
          this.input.dispatchEvent(new Event('change', { bubbles: true }));
        }

        sync() {
          const value = Number(this.input.value);
          const min = this.input.min === '' ? null : Number(this.input.min);
          const max = this.input.max === '' ? null : Number(this.input.max);

          if (Number.isFinite(min) && value < min) this.input.value = String(min);
          if (Number.isFinite(max) && value > max) this.input.value = String(max);

          const normalized = Number(this.input.value);
          this.minus.disabled = Number.isFinite(min) && normalized <= min;
          this.plus.disabled = Number.isFinite(max) && normalized >= max;
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
